import React, { useContext } from 'react';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import NoFiltersChangePosition from 'components/NoFiltersChangePosition/NoFiltersChangePosition';
import ChangePositionControlPanel from './components/ChangePositionControlPanel/ChangePositionControlPanel';
import ChangePositionList from './components/ChangePositionList/ChangePositionList';
import { ModalWindows } from './components/ModalWindows';
import BtnBlock from './components/BtnBlock';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	ChangeComboGroupPositionContext,
	IChangeComboGroupPositionContext,
} from '../../changeComboGroupPositionState/changeComboGroupPositionContext';
import style from './ChangeComboGroupPosition.module.scss';

const ChangeComboGroupPosition: React.FC = () => {
	const { positionsData, IDSelectedDish } = useContext<IChangeComboGroupPositionContext>(
		ChangeComboGroupPositionContext,
	);
	const { isLoading } = useContext<IAppContext>(AppContext);

	return (
		<div className={style.container} data-test="ChangeComboGroupPosition">
			<ChangePositionControlPanel />
			{positionsData?.length ? (
				<>
					<ChangePositionList />
					<BtnBlock />
					<ModalWindows />
				</>
			) : (
				<NoResultsFound isVisible={!isLoading && !!IDSelectedDish} />
			)}
			<NoFiltersChangePosition isVisible={!IDSelectedDish} />
		</div>
	);
};

export default ChangeComboGroupPosition;
